// export DsfHomePendingProcess from './pendingProcess.vue'
export const DsfHomePendingProcess = dsf.defineAsyncComponent("DsfHomePendingProcess", () => import(/*webpackChunkName:"platform_homepage"*/ "./pendingProcess.vue"));
